/* ═══════════════════════════════════════════════════════════════
   MAISON VELMONT — Upsell panier
   Remplace velmont-upsell.js
   ───────────────────────────────────────────────────────────────
   Utilise la Section Rendering API pour rafraîchir le panier et
   l'upsell sans rechargement. Les listeners sont ré-attachables
   puisque le DOM est remplacé après chaque ajout.
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var ICON_PLUS =
    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
    '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  var ICON_CHECK =
    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">' +
    '<polyline points="20 6 9 17 4 12"/></svg>';

  var ICON_SPIN =
    '<svg class="upsell-spin" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
    '<path d="M21 12a9 9 0 11-6.219-8.56"/></svg>';

  /* ── Formatage monétaire ──────────────────────────────────── */
  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
  }

  /* ── Badge panier du header ───────────────────────────────── */
  function updateBadge(count) {
    var link = document.querySelector('.header-cart');
    if (!link) return;

    var badge = link.querySelector('.cart-count');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-count';
        link.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  /* ── Rafraîchissement via Section Rendering API ───────────── */
  function refreshSections() {
    return fetch('/cart?sections=cart-items,cart-upsell')
      .then(function (r) {
        if (!r.ok) throw new Error('sections');
        return r.json();
      })
      .then(function (data) {
        var main = document.querySelector('.cart-main-column');
        if (main && data['cart-items']) {
          main.innerHTML = extractSection(data['cart-items']);
        }

        var aside = document.querySelector('.cart-upsell-column');
        if (aside && data['cart-upsell']) {
          aside.innerHTML = extractSection(data['cart-upsell']);
        }

        bind();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  /* La Section Rendering API renvoie le HTML enveloppé dans
     <div id="shopify-section-…">. On extrait le contenu utile. */
  function extractSection(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var inner = tmp.querySelector('[id^="shopify-section-"]');
    return inner ? inner.innerHTML : html;
  }

  /* ── Ajout au panier ──────────────────────────────────────── */
  function handleAdd() {
    var btn = this;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-loading')) return;

    var inner = btn.querySelector('.upsell-btn__inner');
    var label = btn.querySelector('.upsell-btn__label');
    var original = inner ? inner.innerHTML : '';

    btn.classList.add('is-loading');
    if (inner) {
      inner.innerHTML = ICON_SPIN + '<span class="upsell-btn__label">Ajout…</span>';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (e) {
            throw new Error(e.description || 'Indisponible');
          });
        }
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        if (inner) {
          inner.innerHTML = ICON_CHECK + '<span class="upsell-btn__label">Ajouté</span>';
        }

        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateBadge(cart.item_count);
            return new Promise(function (resolve) {
              setTimeout(resolve, 700);
            });
          })
          .then(refreshSections);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        if (inner) {
          inner.innerHTML =
            '<span class="upsell-btn__label">' + err.message + '</span>';
        }
        setTimeout(function () {
          btn.classList.remove('is-error');
          if (inner) inner.innerHTML = original;
        }, 2600);
      });
  }

  /* ── Attache des listeners (ré-appelable) ─────────────────── */
  function bind() {
    var buttons = document.querySelectorAll('.upsell-btn:not([data-bound])');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.setAttribute('data-bound', 'true');
      btn.addEventListener('click', handleAdd);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
